module.exports = __webpack_public_path__ + "static/media/toronto.4913b868.png";